import TakeBackBagsListItem from './TakeBackBagsListItem';

export default TakeBackBagsListItem;
